export default class FooterToggleButton {
  constructor($toggleButton) {
    this.$toggleButton = $toggleButton;
    this.$menu = document.getElementById(
      this.$toggleButton.getAttribute('aria-controls')
    );

    // Binded events
    this.bindedOnClick = this.onClick.bind(this);

    // Add events
    this.$toggleButton.addEventListener('click', this.bindedOnClick);
  }

  deconstructor() {
    // Remove events
    this.$toggleButton.removeEventListener('click', this.bindedOnClick);

    // Reset panel
    this.closeMenu();
  }

  closeMenu() {
    // Change toggle button
    this.$toggleButton.setAttribute('aria-expanded', 'false');

    // Close menu
    this.$menu.classList.remove('footer__links-menu--open');

    // Add focus back on toggle button
    this.$toggleButton.focus();
  }

  openMenu() {
    // Change toggle button
    this.$toggleButton.setAttribute('aria-expanded', 'true');

    // Show panel
    this.$menu.classList.add('footer__links-menu--open');
  }

  onClick() {
    // Get current state of panel
    const isClosed =
      this.$toggleButton.getAttribute('aria-expanded') !== 'true';

    // Switch state
    window.requestAnimationFrame(() => {
      if (isClosed) {
        this.openMenu();
      } else {
        this.closeMenu();
      }
    });
  }
}
